import { render } from "./Index.vue?vue&type=template&id=73ecf66c"
const script = {}
/* custom blocks */
import block0 from "./Index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/antenehalemayehu/personal/yaya-payment/yaya/public/apps/exchange/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__